    import './App.css';
    import React from 'react';
    import { SwapSlide } from './components/mainComponents/SwapSlider';
    import Header from './components/headerComponents/Header';
    import { Route, Switch } from "react-router-dom";
    import Users from './components/mainComponents/Users';
import WishListPage from './components/mainComponents/WishListPage';
import CartPage from './components/mainComponents/CartPage';
    
    
    function App( ) {
    
      return (
        <React.Fragment>
        <div className="App">
                <Header/>
              <div  className="AppWrapp">
                    <Switch>
                      <Route exact path="/users" component={Users}/>
                      <Route 
                           exact
                           path="/wishlists" 
                           render={() => <WishListPage /> }
                      />
                      <Route 
                           exact path={"/cart"}
                           render={() => <CartPage/> }
                      />
                      <Route 
                           path="/"
                           render={() => <SwapSlide /> }
                       />
                    </Switch>
              </div>
        </div>
      </React.Fragment>
      );
    }
    
    export default App;
    
    
    
    
    





